import { render, staticRenderFns } from "./integral.vue?vue&type=template&id=70a7c944&scoped=true&"
import script from "./integral.vue?vue&type=script&lang=ts&"
export * from "./integral.vue?vue&type=script&lang=ts&"
import style0 from "./integral.vue?vue&type=style&index=0&id=70a7c944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7c944",
  null
  
)

export default component.exports